import * as R      from 'ramda';
import React       from 'react';
import { connect } from 'react-redux';
import PropTypes   from 'prop-types';
import { Helmet }  from 'react-helmet';

import {
  compose,
  defaultProps,
  setPropTypes,
  lifecycle,
  withStateHandlers,
  withHandlers
} from 'recompose';

import MealPeriodTable         from '../components/MealPeriodTable';
import MealPeriodPageToolbar   from '../components/MealPeriodPageToolbar';
import SearchFilter            from '../../../components/SearchFilter';
import FileExportProgressModal from '../../modals/FileExportProgressModal';

import { fetchAutocomplete as _fetchAutocomplete, clearAutocomplete as _clearAutocomplete } from '../../client/ClientActions';

import {
  hideFileExportModal as _hideFileExportModal,
  exportToFile        as _exportToFile
} from '../../file-export/FileExportActions';

import {
  getFileExportError,
  getFileExportLink,
  getShowFileExportModal
} from '../../file-export/FileExportReducer';

import {
  fetchAllMealPeriod  as _fetchAllMealPeriod,
  filterByAction      as _filterByAction,
  transformData       as _transformData,
  setShowSearchFilter as _setShowSearchFilter,
  clearSvrResponses   as _clearSvrResponses,
} from '../MealPeriodActions';

import {
  getCurrentClient,
  getCurrentProject,
  isClientUser,
  getPrefilledFilters,
  getAutoComplete
} from '../../client/ClientReducer';

import {
  getAllMealPeriod,
  // getMealPeriod,
  getTransformedData,
  getTableColumns,
  getFilterList,
  getShowSearchFilter
} from '../MealPeriodReducer';

import {
  getUserRole,
  getUserId,
  getEmail
}                               from '../../auth/AuthReducer';
import { deriveTenancyFilters } from '../../../utils/deriveTenancyFilters';
import { Dialog, DialogTitle, DialogContent, Typography } from '@material-ui/core';
import moment    from 'moment';

const NAMESPACE = 'mealPeriod';
const DEFAULT_NUMBER_OF_DAYS_REPORT_FILTER = 7;

const searchFilterStyle = {
  minHeight       : '10rem',
  margin          : '2rem 2rem 1rem 2rem',
  position        : 'relative',
  backgroundColor : '#FFF',
  boxShadow       : '0px 1px 5px 0px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.12)',
};

// const getStatusCode = label => {
//   return R.compose(
//     R.partialRight(parseInt, [10]),
//     R.head,
//     R.find(R.compose(R.equals(label), R.last)),
//     R.toPairs
//   )(window.WINSTON.statuses.savedView);
// };

const MealPeriodPage = ({
  mealPeriods,
  prefilledFilters,
  fetchAutocomplete,
  clearAutocomplete,
  autoComplete,
  transformedData,
  transformedDataDict,
  tableColumns,
  filterList,
  goToReviewPage,
  updateSvrResponse,
  deleteSvrResponse,
  maybeFilterByAction,
  showSearchFilter,
  setShowSearchFilter,
  transformData,
  userRole,
  userId,
  currentClient,
  currentProject,
  savedView,
  title,
  description,
  createSavedView,
  createSavedWidget,
  createSavedRollup,
  namespace,
  userEmail,
  deleteSavedView,
  exportToFile,
  showFileExportModal,
  hideFileExportModal,
  fileExportLink,
  fileExportError,
  isClientUser,
  handleSelectData,
  selectedData,
  isFetchingData,
  syncFilters
}) => (
  <div>
    <Helmet>
      <title>Meal Period</title>
    </Helmet>
    <SearchFilter
      data            = { R.flatten(mealPeriods) }
      prefilledFilters= { prefilledFilters }
      fetchAutocomplete= {fetchAutocomplete}
      clearAutocomplete= {clearAutocomplete}
      autoComplete     = {autoComplete}
      transformedData = { transformedData }
      tableColumns    = { R.filter(R.prop('searchable'), tableColumns) }
      filterByAction  = { maybeFilterByAction }
      filterList      = { filterList }
      syncFilters     = { syncFilters }
      namespace       = { namespace }
      style           = { searchFilterStyle }
      userRole        = { userRole }
      userId          = { userId }
      currentClient   = { currentClient }
      currentProject  = { currentProject }
      isClientUser    = { isClientUser() }
      allowSave       = { true }
      showWhen        = { showSearchFilter }
      onSaveAsView    = { createSavedView }
      onSaveAsWidget  = { createSavedWidget }
      onSaveAsRollup  = { createSavedRollup }
    />
    <MealPeriodPageToolbar
      selectedData = { selectedData }
      onExport     = { type => {
        exportToFile({
          title,
          type,
          transformedData : selectedData,
          namespace,
          tableColumns
        });
      }}
    />
    {
      showFileExportModal && (
        <FileExportProgressModal
          fileExportLink  = {fileExportLink}
          fileExportError = {fileExportError}
          onApprove       = {hideFileExportModal}
        />
      )
    }
    <MealPeriodTable
      transformedData     = { transformedData }
      transformedDataDict = { transformedDataDict }
      data                = { mealPeriods }
      title               = { title }
      description         = { description }
      tableColumns        = { tableColumns }
      savedView           = { savedView }
      deleteSavedView     = { deleteSavedView }
      onUpdate            = { updateSvrResponse }
      onHardDelete        = { deleteSvrResponse }
      transformData       = { transformData }
      userRole            = { userRole }
      filterList          = { filterList }
      goToReviewPage      = { goToReviewPage }
      setShowSearchFilter = { setShowSearchFilter }
      showSearchFilter    = { showSearchFilter }
      userEmail           = { userEmail }
      isClientUser        = { isClientUser() }
      handleSelectData    = { handleSelectData }
      namespace           = { namespace }
    />

    <Dialog
      open    = {isFetchingData}
      fullWidth = {true}
    >
      <DialogTitle>Loading...</DialogTitle>
      <DialogContent style={{ justifyContent : 'space-between' }}>
        <Typography>Please wait</Typography>
      </DialogContent>
    </Dialog>
  </div>
);

const manageSvrResponsesFilterList = () => {
  
  // return {
  //   'Review State': {
  //     pathStr: 'metaJson.reviewState',
  //     path: ['metaJson', 'reviewState'],
  //     label: 'Review State',
  //     decorator: v => window.WINSTON.statuses.reviewState[v || 0],
  //     data: R.compose(
  //       values => R.filter(v => R.equals('Pending Review', v) || R.equals('Resubmitted', v), values),
  //       R.values
  //     )(window.WINSTON.statuses.reviewState)
  //   }
  // };

  var todayDate = new Date().toISOString().slice(0, 10);
  todayDate = todayDate.concat(" 23:59:59");  

  const now = moment();
  const pastdate = moment(now).subtract(DEFAULT_NUMBER_OF_DAYS_REPORT_FILTER, 'days').format("YYYY-MM-DD");
  
  var visitArray = [];
  var visitArrayClone = [];
  visitArray.push([pastdate, todayDate]);
  visitArrayClone.push(visitArray);

  return {
    'Visit Date': {
      pathStr: 'expectedCheckinTime',
      path: ['expectedCheckinTime'],
      label: 'Visit Date',
      //decorator: v => window.WINSTON.statuses.reviewState[v || 0],
      decorator: R.path(['WINSTON', 'tableColumns', 'storeVisit', "expectedCheckinTime", 'decorator'])(window),
      data: visitArrayClone
    }
  };
};

const maybeLoadInitialFilterListFromRouterProps = (state, props) => {

  let storedFilters = {};
  try {
    storedFilters = R.compose(
      maybeAppendDecorators,
      appendFilterType,
      JSON.parse
    )(window.localStorage.getItem(`persistedFilters:${props.namespace}`));
  } catch (e) {
    storedFilters = {};
  }
  var objFilterSize = Object.keys(storedFilters).length;
  if (objFilterSize === 0 && !isClientUser()) {
    return R.compose(
      maybeAppendDecorators,
      appendFilterType,
      R.mergeDeepLeft(deriveTenancyFilters(getCurrentClient(state), getCurrentProject(state))),
      R.mergeDeepRight(props.filterList || R.pathOr({}, ['savedView', 'filters'])(props)),
      R.when(R.isEmpty, R.always(props.initialFilterList || {})),
      manageSvrResponsesFilterList,
      R.mergeDeepLeft(storedFilters),
      getFilterList(props.namespace)
    )(state);
  }
  else if(objFilterSize === 1 && storedFilters.hasOwnProperty('Client Name') /*&& !isClientUser()*/)
  {
    return R.compose(
      maybeAppendDecorators,
      appendFilterType,
      R.mergeDeepLeft(deriveTenancyFilters(getCurrentClient(state), getCurrentProject(state))),
      R.mergeDeepRight(props.filterList || R.pathOr({}, ['savedView', 'filters'])(props)),
      R.when(R.isEmpty, R.always(props.initialFilterList || {})),
      manageSvrResponsesFilterList,
      R.mergeDeepLeft(storedFilters),
      getFilterList(props.namespace)
    )(state);
  }
  else
  {
  return R.compose(
    maybeAppendDecorators,
    appendFilterType,
    R.mergeDeepLeft(deriveTenancyFilters(getCurrentClient(state), getCurrentProject(state))),
    R.mergeDeepRight(props.filterList || R.pathOr({}, ['savedView', 'filters'])(props)),
    R.when(R.isEmpty, R.always(props.initialFilterList || {})),
    R.mergeDeepLeft(storedFilters),
    getFilterList(props.namespace)
  )(state);
  }
};

const maybeDispatchFetchSvrResponses = (dispatch, namespace, filters) => {
  const activeFilters = R.filter(R.compose(R.not, R.isEmpty, R.prop('data')))(filters);
  if(Object.keys(activeFilters).length) {
    return dispatch(_fetchAllMealPeriod(namespace, filters));
  }
  dispatch(_clearSvrResponses(namespace));
  return Promise.resolve();
};

function _goToReviewPage(props, id) {
  return (dispatch, getState) => {
    window.localStorage.setItem("displayUnansweredSections", 'NO');
    if (!R.isNil(window.localStorage.getItem('dashboardId')) && !R.isEmpty(window.localStorage.getItem('dashboardId'))) {
      window.localStorage.removeItem('dashboardId')
    }
    const state = getState();
    const currentIds = R.compose(R.map(d => { return { id: d.id }; } ), R.pathOr([], [NAMESPACE, props.namespace, 'transformedData']))(state);
    props.history.push(`/svr-response/${id}`, { ids: currentIds });
  };
}

const mapStateToProps = (state, props) => ({
  mealPeriods         : getAllMealPeriod(state, props.namespace || NAMESPACE),
  transformedData     : getTransformedData(state, props.namespace || NAMESPACE),
  transformedDataDict : R.indexBy(R.prop('id'),  getTransformedData(state, props.namespace || NAMESPACE) || []),
  tableColumns        : getTableColumns(props.namespace || NAMESPACE)(state),
  userRole            : getUserRole(state),
  userId              : getUserId(state),
  userEmail           : getEmail(state),
  currentClient       : getCurrentClient(state),
  currentProject      : getCurrentProject(state),
  showSearchFilter    : getShowSearchFilter(state),
  filterList          : maybeLoadInitialFilterListFromRouterProps(state, props),
  showFileExportModal : getShowFileExportModal(state),
  fileExportLink      : getFileExportLink(state),
  fileExportError     : getFileExportError(state),
  prefilledFilters    : getPrefilledFilters(state),
  autoComplete        : getAutoComplete(state),
  isClientUser
});

const mapDispatchToProps = (dispatch, props) => ({
  dispatch,
  fetchSvrResponses   : (namespace, filters) => dispatch(_fetchAllMealPeriod(namespace, filters)),
  // updateSvrResponse   : (namespace, svrResponseId, payload) => dispatch(_updateSvrResponse(namespace, svrResponseId, payload)),
  // deleteSvrResponse   : id => dispatch(_deleteSvrResponse(id)),
  goToReviewPage      : id => dispatch(_goToReviewPage(props, id)),
  persistFilters      : (namespace, filters) => dispatch(_filterByAction(namespace, filters)),
  setShowSearchFilter : bool => dispatch(_setShowSearchFilter(bool)),
  transformData       : (orderBy, order, sortType, filterList, data, namespace) => dispatch(_transformData(orderBy, order, sortType, filterList, data, namespace)),
  hideFileExportModal : payload => dispatch(_hideFileExportModal(payload)),
  exportToFile        : payload => dispatch(_exportToFile(payload)),
  fetchAutocomplete   : payload => dispatch(_fetchAutocomplete(payload)),
  clearAutocomplete   : () => dispatch(_clearAutocomplete()),
});

const maybeAppendDecorators = R.map((filter={}) => {
  const decorator = R.path(['WINSTON', 'tableColumns', 'mealPeriod', filter.pathStr, 'decorator'])(window);
  if (R.is(Function, decorator)) {
    return R.assoc('decorator', decorator, filter);
  } else {
    return filter;
  }
});

const appendFilterType = R.map((filter={}) => {
  const type = R.path(['WINSTON', 'tableColumns', 'mealPeriod', filter.pathStr, 'type'])(window);
  return R.assoc('type', type, filter);
});

const withMealPeriod = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStateHandlers(
    ({
      selectedData = [],
      isFetchingData = false,
    }) => ({
      selectedData,
      isFetchingData
    }),
    ({
      handleSelectData: (__, { transformedData }) => selectedData => {
        if (selectedData.length > 0) {
          return {
            selectedData: R.compose(
              R.filter(d => R.contains(d.id, selectedData))
            )(transformedData)
          };
        }

        return { selectedData };
      },
      setFetchingData : () => fetching => ({
        isFetchingData: fetching
      })
    }),
  ),
  withHandlers({
    filterByAction : props => (namespace, filters) =>
      Promise.resolve(props.setFetchingData(true))
      .then(() => props.dispatch(_fetchAllMealPeriod(namespace, filters)))
      .then(() => props.dispatch(_filterByAction(namespace, filters)))
      .then(() => props.setFetchingData(false))
    ,
    maybeFilterByAction : props => (namespace, filters) =>
      Promise.resolve(props.setFetchingData(true))
      .then(() => maybeDispatchFetchSvrResponses(props.dispatch, namespace, filters))
      .then(() => props.dispatch(_filterByAction(namespace, filters)))
      .then(() => props.setFetchingData(false)),
    syncFilters : props => (namespace, filters) => props.dispatch(_filterByAction(namespace, filters))
    ,
  }),
  defaultProps({
    mealPeriods       : [],
    savedView         : {},
    savedViews        : [],
    transformedData   : [],
    tableColumns      : [],
    showSearchFilter  : false,
    initialFilterList : {},
    namespace         : NAMESPACE,
    isClientUser      : () => {}
  }),
  setPropTypes({
    mealPeriods         : PropTypes.array,
    savedViews          : PropTypes.array,
    savedView           : PropTypes.object,
    transformedData     : PropTypes.array,
    title               : PropTypes.string,
    description         : PropTypes.string,
    tableColumns        : PropTypes.array,
    // updateSvrResponse   : PropTypes.func.isRequired,
    // deleteSvrResponse   : PropTypes.func.isRequired,
    createSavedView     : PropTypes.func,
    createSavedWidget   : PropTypes.func,
    createSavedRollup   : PropTypes.func,
    showSearchFiler     : PropTypes.bool,
    setShowSearchFilter : PropTypes.func,
    filterList          : PropTypes.object.isRequired,
    initialFilterList   : PropTypes.object,
    userRole            : PropTypes.number.isRequired,
    userId              : PropTypes.number.isRequired,
    isClientUser        : PropTypes.func
  }),
  lifecycle({
    componentDidMount() {
      this.props.setShowSearchFilter(true);
    },
    componentDidUpdate(prevProps) {
      const savedViewUpdated         = !R.equals(prevProps.savedView,         this.props.savedView),
            filterListUpdated        = !R.equals(prevProps.filterList,        this.props.filterList),
            initialFilterListUpdated = !R.equals(prevProps.initialFilterList, this.props.initialFilterList);

      const filters = this.props.filterList || {};

      if (savedViewUpdated || initialFilterListUpdated) {
        this.props.maybeFilterByAction(this.props.namespace, filters);
      }

      else if (filterListUpdated) {
        this.props.persistFilters(this.props.namespace, filters);
      }
    }
  })
);

export default withMealPeriod(MealPeriodPage);
